import React from 'react';

const UnderReview = ({ className, fill }) => {
  return (
<svg 
className={className}
version="1.0" 
xmlns="http://www.w3.org/2000/svg"
 width="50.000000pt" 
 height="50.000000pt" 
 viewBox="0 0 50.000000 50.000000"
 preserveAspectRatio="xMidYMid meet">

<g transform="translate(0.000000,50.000000) scale(0.100000,-0.100000)"
/* fill="#000000" */ stroke="none">
<path d="M195 481 c-111 -29 -179 -116 -179 -231 0 -138 96 -234 234 -234 138
0 234 96 234 234 0 95 -44 169 -125 210 -42 22 -121 32 -164 21z m65 -135 l0
-85 53 -3 c38 -2 52 -7 52 -18 0 -11 -14 -16 -58 -18 -81 -4 -87 3 -87 108 0
88 3 100 27 100 10 0 13 -21 13 -84z"/>
</g>
</svg>

   
  )
}
export default UnderReview;